import { Button, Popconfirm, Tag } from "antd";
import { LockOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useUserPermissions } from "@components/PermissionedComponents";
import { deleteCalendarTag } from "@store/actions/team.actions";
import { TagAvatar } from "@components/Avatars/TagAvatar";
import "@styles/styles-CalendarTagsList.css";

interface CalendarTag {
  id: string;
  label: string;
  color: string;
  icon: string;
  is_internal: boolean;
  created_by_id: number | null;
}

interface CalendarTagsListProps {
  onEdit: (tag: CalendarTag) => void;
  onCreateClick: () => void;
}

export const CalendarTagsList = ({ onEdit, onCreateClick }: CalendarTagsListProps) => {
  const dispatch = useDispatch();
  const { calendarTags } = useSelector(({ team }: any) => team);
  const canManage = useUserPermissions()?.ManageCalendarTags;

  const tags: CalendarTag[] = Object.values(calendarTags);
  const sorted = [...tags].sort((a, b) => {
    if (a.is_internal && !b.is_internal) return -1;
    if (!a.is_internal && b.is_internal) return 1;
    return a.label.localeCompare(b.label);
  });

  const handleDelete = (id: string) => {
    dispatch(deleteCalendarTag(id) as any);
  };

  return (
    <div className="calendar-tags-list">
      <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 2, padding: "4px 0" }}>
        {sorted.map((tag) => {
          const canEditDelete = canManage && !tag.is_internal;
          return (
            <Tag
              key={tag.id}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 4,
                padding: "4px 10px",
                borderRadius: 16,
                border: "1px solid #d9d9d9",
                background: "#fff",
                fontSize: 13,
              }}
            >
              <TagAvatar tag={tag} size={18} showTooltip={false} />
              {tag.label}
              {tag.is_internal && <LockOutlined style={{ fontSize: 10 }} title="System tag" />}
              {canEditDelete && (
                <>
                  <EditOutlined style={{ cursor: "pointer", marginLeft: 2 }} onClick={() => onEdit(tag)} />
                  <Popconfirm
                    title="Delete this tag?"
                    description="All calendar assignments for this tag will be hidden."
                    onConfirm={() => handleDelete(tag.id)}
                    okText="Delete"
                    okButtonProps={{ danger: true }}
                  >
                    <DeleteOutlined style={{ cursor: "pointer" }} />
                  </Popconfirm>
                </>
              )}
            </Tag>
          );
        })}
        {canManage && (
          <Button size="small" onClick={onCreateClick}>
            + Create Tag
          </Button>
        )}
      </div>
    </div>
  );
};
